class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.isCartPage = document.getElementById("main-cart-wrapper");

        //this.setInitialItemCountAndEmptyStatus();
        this.setupElements();
        this.setupListeners();
    }

    enableLoading(line) {
        document.getElementById('cart-drawer-items-main')?.classList.add('cart__items--disabled')
        this.querySelectorAll(`#MainCartDraweritem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'))
        document.activeElement?.blur()
        this.getLineItemStatusElement()?.setAttribute('aria-hidden', false)
    }

    disableLoading() {
        document.getElementById('cart-drawer-items-main')?.classList.remove('cart__items--disabled')
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'))
        this.getLineItemStatusElement()?.setAttribute('aria-hidden', true)
    }

    // The status element sits inside `.cart-drawer-items`, which is replaced on every
    // re-render, so it must be looked up fresh rather than cached in setupElements().
    getLineItemStatusElement() {
        return document.getElementById('cart-drawer-line-item-status')
    }

    setInitialItemCountAndEmptyStatus() {

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]')
        ).reduce((total, quantityInput) => {
            return total + parseInt(quantityInput.value);
        }, 0);

        this.cartIsEmpty = !!!this.currentItemCount;
    }

    setupElements() {
        this.cartDrawerHeader = this.querySelector(".cart-drawer-header h3");
            this.cartAccessibleMessage = this.querySelector(".cart-drawer-title__cart-accessible-message")
        this.lineItemStatusElement = document.getElementById(
            "cart-drawer-line-item-status"
        );
        this.drawerOverlay = document.getElementById("cart-drawer-overlay");
        this.cartDrawerCloseBtn = document.getElementById(
            "CartDrawerDrawerClose"
        );
        this.cartBubble = document.getElementById("cart-icon-bubble");
        this.cartSection = document.getElementById("shopify-section-cart-drawer");
        if (this.cartSection) this.cartSection.style.display = "none";
    }

    updateQuantity(line, quantity, name, recipe, element) {

        this.enableLoading(line);

        // Set-up fee lines only ever exist once per recipe; they are pinned to quantity 1.
        const increaseTheseOnce = ["MCS Setup Fees", "1 Color Print Set Up", "1 Color RE-Set Up", "2 Color Print Set Up", "2 Color RE-Set Up", "Multicolor Print Set Up", "Multicolor RE-Set Up", "Laser Etch Set Up", "Laser Etch RE-Set Up"];
        const lineKey = element?.dataset?.key;

        // The update is built from the live cart (/cart.js) instead of scraping
        // data-productkey attributes out of the page. The DOM can hold stale or
        // duplicated keys after a re-render, and a single key that no longer
        // matches a cart line makes Shopify reject the whole update.
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                const relevantItems = cart.items
                    .filter((item) => {
                        if (recipe) return item.properties && item.properties._Recipe === recipe
                        return lineKey && item.key === lineKey
                    })
                    .map((item) => ({ key: item.key, title: item.product_title }))

                // Cart changed underneath us — refresh the display instead of
                // sending an update that can no longer apply.
                if (!relevantItems.length) return

                const hitURL = spectrumBuildUpdate(relevantItems, quantity, increaseTheseOnce)

                return fetch(hitURL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line, quantity })
                }).then((response) => response.text())
            })
            .then(() => this.updateCartDisplay())
            .catch((e) => {
                console.error('Cart drawer quantity update failed:', e)
                this.disableLoading()
            })
    }

    setupListeners() {
        this.addEventListener(
            "change",
            debounce((event) => {
                if (event.target.getAttribute("id") == "CartDrawer-note")
                    return;

                this.updateQuantity(
                    event.target.dataset.index,
                    event.target.value,
                    document.activeElement.getAttribute('name'), 
                    event.target.dataset.recipe, 
                    event.target
                );
            }, 300)
        );

        this.cartDrawerCloseBtn?.addEventListener("click", () => this.close());
        this.drawerOverlay?.addEventListener("click", () => this.close());
        this.cartBubble?.addEventListener("click", (event) => { event.preventDefault(); this.open(); });
        this.setCloseListeners();
    }

    setCloseListeners() {
        document.addEventListener("keyup", (e) => {
            if (e.code == "Escape") this.close();
        });
    }

    open(accessibleMessage) {

        // close menu drawer if open before opening cart drawer
        const navDrawer = document.querySelector('header-drawer');
        if (navDrawer?.mainDetailsToggle?.hasAttribute('open')) {
            navDrawer.closeMenuDrawer(null);
            navDrawer.mainDetailsToggle.removeAttribute('open');
        }

        this.cartSection.style.display = "block"

        this.drawerOverlay.classList.replace("closed", "open");
        this.classList.replace("closed", "open");

        this.cartDrawerHeader?.focus();

        this.updateCartMessage(accessibleMessage)

        this.dispatchEvent(new CustomEvent("cart-drawer:opened", { bubbles: true }));
    }

    // Re-runs inline <script> tags inside a freshly injected node (the Spectrum
    // fee tables in the line-item markup depend on this). Accepts an element.
    reinitializeSectionScripts(section) {
        if (typeof section === "string") section = document.getElementById(section) || document.querySelector(section);
        if (!section) return;

        const scripts = Array.from(section.querySelectorAll("script"));

        scripts.forEach((oldScript) => {
            const newScript = document.createElement("script");

            Array.from(oldScript.attributes).forEach((attr) =>
                newScript.setAttribute(attr.name, attr.value)
            );

            newScript.textContent = oldScript.textContent;

            oldScript.replaceWith(newScript);
        });
    }

    updateCartMessage(accessibleMessage) {
        if (!this.cartAccessibleMessage) return;

        if (!accessibleMessage) {
            this.cartAccessibleMessage.removeAttribute('aria-label')
            this.cartAccessibleMessage.innerHTML = ''
            return;
        }
        this.cartAccessibleMessage.setAttribute('aria-label', accessibleMessage)
        this.cartAccessibleMessage.innerHTML = accessibleMessage
    }

    close() {
        this.classList.replace("open", "closed");
        this.drawerOverlay.classList.replace("open", "closed");

        this.cartSection.style.display = "none"
    }

    getSectionInnerHTML(html, selector) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const el = doc.querySelector(selector);
        return el ? el.innerHTML : "";
    }

    // Regions of the drawer that are replaced from a fresh render of the
    // `cart-drawer` section. All three come from one request (see updateCartDisplay).
    getSectionsToRender() {
        return [
            {
                id: "cart-drawer-items",
                shopifyfile: "cart-drawer",
                selector: ".cart-drawer-items",
                reinitScripts: true,
            },
            {
                id: "cart-drawer-footer-main",
                shopifyfile: "cart-drawer",
                selector: "#cart-drawer-footer-main .js-contents",
            },
            {
                id: "cart-drawer-shipping-indicator",
                shopifyfile: "cart-drawer",
                selector: "#cart-drawer-shipping-indicator",
            },
        ];
    }

    // Fetches a fresh render of the cart-drawer section through the Section
    // Rendering API and returns it as a parsed document.
    fetchDrawerSection() {
        return fetch(`${window.location.pathname}?sections=cart-drawer`)
            .then((response) => {
                if (!response.ok) throw new Error(`Section render failed (${response.status})`);
                return response.json();
            })
            .then((sections) => new DOMParser().parseFromString(sections["cart-drawer"] || "", "text/html"));
    }

    // For updating the display on demand, called by other scripts after any cart
    // mutation. Arguments passed by callers are ignored: the drawer always re-renders
    // from a fresh section fetch. Concurrent calls are coalesced so a burst of
    // quantity changes ends with exactly one final render.
    updateCartDisplay() {
        if (this._refreshing) {
            this._refreshQueued = true;
            return this._refreshing;
        }

        this._refreshing = this.fetchDrawerSection()
            .then((doc) => {
                let scriptsRoot = null;

                this.getSectionsToRender().forEach((section) => {
                    const current = this.querySelector(section.selector);
                    const fresh = doc.querySelector(section.selector);

                    if (!current || !fresh) {
                        console.warn(`Cart drawer: could not update ${section.selector}`);
                        return;
                    }

                    current.replaceWith(fresh);
                    if (section.reinitScripts) scriptsRoot = fresh;
                });

                if (scriptsRoot) this.reinitializeSectionScripts(scriptsRoot);

                const freshDrawer = doc.querySelector("cart-drawer");
                this.cartIsEmpty = !!freshDrawer && freshDrawer.classList.contains("is-empty");
                this.updateEmptyCartDrawerState();
            })
            .catch((err) => console.error("Cart drawer: error refreshing:", err))
            .finally(() => {
                this._refreshing = null;
                this.disableLoading();

                if (this._refreshQueued) {
                    this._refreshQueued = false;
                    this.updateCartDisplay();
                    return;
                }

                document.dispatchEvent(new Event("postCartAction"));
            });

        return Promise.all([this._refreshing, this.updateCartBubble()]);
    }

    updateCartBubble() {
        const cartBubble = document.getElementById('cart-icon-bubble');
        if (!cartBubble) return Promise.resolve();

        return fetch(`${window.location.pathname}?section_id=cart-icon-bubble`)
            .then(res => res.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const newContent = doc.querySelector('.shopify-section');
                if (newContent) {
                    cartBubble.innerHTML = newContent.innerHTML;
                }
            })
            .catch(err => console.error('❌ Error updating cart bubble:', err));
    }

    renderContents(parsedState, shouldOpen = true) {

        console.log("renderContents: ", parsedState);

        console.log("render these sections: ", this.getSectionsToRender());

        this.getSectionsToRender().forEach((section) => {
            this.updateDrawerSectionHTMLWithSectionStr(section, parsedState);
            this.updateMainCartSectionHTMLWithSectionStr(section, parsedState);
        });

        this.updateEmptyCartDrawerState();
    }

    postQuantityDisplayUpdate(state, line, name) {
        const parsedState = JSON.parse(state);

        this.cartIsEmpty = parsedState.item_count === 0;
        this.currentItemCount = parsedState.item_count;

        this.getSectionsToRender().forEach((section) => {
            this.updateDrawerSectionHTMLWithSectionStr(section, parsedState);
            this.updateMainCartSectionHTMLWithSectionStr(section, parsedState);
        });

        this.updateEmptyCartDrawerState();
        this.reloadCartPageIfEmpty();

        document.dispatchEvent(new Event("postCartAction"));
    }

    updateMainCartSectionHTMLWithSectionStr(section, parsedState) {
        if (section.cartPageReserved && this.isCartPage) {
            const sectionElement = document.querySelector(
                "#main-cart-wrapper #" + section.id
            );
            const childSection = sectionElement.querySelector(section.selector);
            const fallbackSection = document.getElementById(section.id);
            const elementToReplace = childSection || fallbackSection;

            setInnerHTML(
                elementToReplace,
                this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                )
            );
        }
    }

    updateDrawerSectionHTMLWithSectionStr(section, parsedState) {

        console.log("updateDrawerSectionHTML()", section);
        console.log("section.section: ", section.section);
        console.log("PARSED STATE TEST: ", parsedState);

        if (!section.cartPageReserved) {
            const sectionElement = document.getElementById(section.id);
            const childSection = sectionElement.querySelector(section.selector);
            const fallbackSection = document.getElementById(section.id);
            const elementToReplace = childSection || fallbackSection;

            setInnerHTML(
                elementToReplace,
                this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                )
            );
        }
    }

    updateEmptyCartDrawerState() {
        const isEmpty = !!this.cartIsEmpty;

        this.classList.toggle("is-empty", isEmpty);
        document.getElementById("main-cart-items")?.classList.toggle("is-empty", isEmpty);
    }

    reloadCartPageIfEmpty() {
        let cartItems = document.querySelectorAll(
            "#shopify-section-main-cart-form #main-cart-items .js-contents > .main-cart-item"
        );
        let cartPageItemsContainer = document.querySelectorAll(
            "#shopify-section-main-cart-form #main-cart-items"
        );
        if (!cartItems.length && cartPageItemsContainer.length)
            location.reload();
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            document
                .getElementById(`CartDrawerLine-item-error-${line}`)
                .querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    document.getElementById(`CartDrawerQuantity-${line}`).value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);
        const cartStatus = document.getElementById(
            "cart-drawer-live-region-text"
        );
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }
}

customElements.define("cart-drawer", CartDrawer);

function updateShoppingGivesText() {
  // Title: "Thanks for making an impact!" → "Want to donate more?"
  const titleEl = document.querySelector('#cc-shop-give, .cc-shop-give');
  if (titleEl) {
    titleEl.textContent = 'Want to donate more?';
  }

  // Description under title:
  // "Do you want to give back today? Add a donation of your own to"
  // → "Get a FREE Climate+ Tumbler with every $5 donation to support"
  const descEl = document.querySelector('.sg-text-wrap');
  if (descEl) {
    descEl.textContent = 'Get a FREE Climate+ Tumbler with every $5 donation to support';
  }

  // Hide "Powered by ShoppingGives"
  const logoEl = document.querySelector('.powered-by-logo');
  if (logoEl) {
    logoEl.style.display = 'none';
  }
}
// Run once on initial load (cart drawer present but before interactions)
document.addEventListener('DOMContentLoaded', function () {
  // Give the ShoppingGives script a moment to inject its HTML
  setTimeout(updateShoppingGivesText, 500);
});

// Run every time the cart drawer content updates
document.addEventListener('postCartAction', function () {
  // Cart sections have just been re-rendered; update widget text again
  setTimeout(updateShoppingGivesText, 300);
});
